// extracted by mini-css-extract-plugin
module.exports = {"container":"CardRouletteList_container__lA7It","number":"CardRouletteList_number__DSPRz"};